import React from 'react';
import { Step } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';
import { DocumentSteps } from '../CreateDocument';

type StepsHeader = {
  primaryColor: string;
  onClick?: () => void;
  currentStep: DocumentSteps;
}

export const StepsHeader: React.FC<StepsHeader> = ({ primaryColor, onClick = () => { }, currentStep }) => {
  const { t } = useTranslation();
  return (
    <div className="mb-5 flex items-center justify-center md:mb-3">
      <Step
        primaryColor={primaryColor}
        onClick={onClick}
        active={currentStep === DocumentSteps.create}
        label={t(translations.COMMON.CREATE)}
        icon="crea"
        done={[DocumentSteps.share, DocumentSteps.sign].includes(currentStep)}
      />
      <Step
        primaryColor={primaryColor}
        onClick={onClick}
        active={currentStep === DocumentSteps.share}
        label={t(translations.COMMON.SHARE)}
        icon="comparte"
        done={[DocumentSteps.sign].includes(currentStep)}
      />
      <Step
        primaryColor={primaryColor}
        onClick={onClick}
        active={currentStep === DocumentSteps.sign}
        label={t(translations.COMMON.SIGN)}
        icon="firma"
        done={false}
      />
    </div>
  );
};
